module.exports = __webpack_public_path__ + "img/island.207e9e99.png";